import { render, staticRenderFns } from "./DeletionConfirm.vue?vue&type=template&id=fcbe884e&"
import script from "./DeletionConfirm.vue?vue&type=script&lang=js&"
export * from "./DeletionConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports